<nav class="custom-breadcrumbs">
	@for (item of breadcrumbList; track $index) {
	@if ($index === breadcrumbList.length-1) {
	<span class="custom-breadcrumb-item active-breadcrumb">
		{{ item.name }}
	</span>
	}@else {
	<a [routerLink]="item.path" class="custom-breadcrumb-item">
		{{ item.name }}
	</a>
	}
	}
</nav>